import React from 'react';

function PrintButton({handlePrint}) {
    return (
        <button type="button" className="learn-share-btn" onClick={handlePrint} aria-label="Print">
            <svg
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <polyline points="6 9 6 2 18 2 18 9"></polyline>
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                <rect x="6" y="14" width="12" height="8"></rect>
                <line x1="6" y1="18" x2="18" y2="18"></line>
            </svg>
            <span>Print</span>
        </button>
    );
}

export default PrintButton;
